export const DEFAULT_DIAGNOSIS_TEXT =
	'F84.0 will be applied as the default diagnosis. You can add any additional diagnosis information in the field below.';
